export default __webpack_public_path__ + "static/media/03_DAIF_Eco_01_02_end.58ed3c64.jpg";